import { createFileRoute } from '@tanstack/react-router';

import { CrewsPage } from '@/features/siteplan/crews-page';

export const Route = createFileRoute('/_app/projects/$projectId/workforce/crews')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <CrewsPage projectId={projectId} />;
}
